// Contenus des pages statiques, FR / EN / ES
const fr = {
  methodo: {
    eyebrow: "Méthodologie",
    title: "Comment Cayus mesure, et ce qui ne traverse jamais le mur.",
    lead: "À gauche, la machine calcule. À droite, les humains lisent des mots. Voici le voyage complet d'un signal.",
    journeyEyebrow: "Le voyage d'un signal",
    journeyTitle: "Sept étapes, un mur",
    journey: [
  { t: "Consentement", d: "Le leader connecte son propre compte, révocable à tout moment.", who: "personne" },
  { t: "Lecture Microsoft Graph", d: "Les signaux de travail (messages, calendrier, réunions) sont lus via l'API.", who: "la machine seule" },
  { t: "Extraction, puis suppression", d: "Le texte est lu une fois pour en tirer une observation, puis effacé.", who: "personne, le texte n'existe plus" },
  { t: "Accumulation sur 8 semaines", d: "Les preuves s'accumulent sur des fenêtres glissantes, contre sa propre baseline.", who: "la machine seule" },
  { t: "LE MUR", d: "Un niveau est placé quand la preuve suffit. Sinon, Building Evidence. Aucun chiffre ne traverse.", who: "personne encore", wall: true },
  { t: "Mirror", d: "Le manager y lit son étape, ses comportements expliqués en une phrase, et ses propres mots.", who: "le leader, seul" },
  { t: "Compass & Radar", d: "Validation de ce qu'il travaille chaque semaine ; vues d'ensemble par groupes de 8 personnes minimum, sans aucun nom.", who: "RH & direction, des groupes décrits avec des mots, jamais des noms" },
],
    laddersEyebrow: "Les six Behaviour Ladders",
    laddersTitle: "Six comportements, lus en mots",
    ladders: [
  { n: "Clear asks", d: "Des demandes qui portent le quoi, le qui et le quand.", ex: "Vos demandes portent le quoi et le qui ; le quand glisse encore." },
  { n: "Relationship investment", d: "L'attention réellement donnée à ses relations de travail.", ex: "Les réponses à votre propre équipe attendent plus longtemps que les réponses vers le haut." },
  { n: "Recognition", d: "Reconnaître les efforts autant que les résultats.", ex: "Vous avez reconnu les résultats plus que les efforts cette fenêtre." },
  { n: "Sustainable rhythm", d: "Un rythme de travail qui tient dans la durée.", ex: "Votre envoi en soirée a augmenté ces quinze derniers jours." },
  { n: "Development focus", d: "Le temps consacré à apprendre et à faire grandir.", ex: "Votre temps d'apprentissage a disparu en semaine cinq et n'est pas revenu." },
  { n: "Connecting the organisation", d: "Créer des liens qui vivent sans vous. (Senior uniquement)", ex: "Le binôme que vous avez créé entre votre équipe et les opérations a continué trois fois au calendrier sans vous." },
],
    levelsEyebrow: "L'échelle",
    levelsTitle: "Quatre étapes nommées, jamais de chiffres",
    levels: [
  { n: "Emerging", c: "#DBEAFE", d: "La pratique apparaît, de façon occasionnelle." },
  { n: "Establishing", c: "#93C5FD", d: "Elle se répète, dans plusieurs contextes." },
  { n: "Consistent", c: "#0047AB", d: "Presque à chaque occasion, dans la durée." },
  { n: "Multiplying", c: "#1E3A8A", d: "Elle se diffuse chez les autres, évaluée depuis les seuls artefacts du leader." },
],
    buildingQuote: "Quand la fenêtre ne contient pas assez d'occasions pour se prononcer, Cayus dit \"en construction\" plutôt que de deviner.",
    changeEyebrow: "Le module Changement",
    changeTitle: "Deux comportements de plus pour les périodes de changement",
    changeText: "Activées sur des périodes déclarées pendant une transformation : les fenêtres actives sont visibles et choisies, jamais silencieuses.",
    principesEyebrow: "Les principes",
    principesTitle: "Quatre garde-fous",
    principes: [
  "Part d'opportunités, jamais volume brut. Être moins sollicité ne pénalise personne.",
  "Baseline personnelle, jamais de comparaison entre leaders.",
  "Pas de décote en congé, les absences n'abîment aucune lecture.",
  "Attribution ordonnée, chaque preuve est rattachée à la bonne fenêtre, au bon contexte.",
],
    survey: "Enquête annuelle",
    surveyText: "Déclaratif, une fois par an, une perception après coup : les résultats arrivent quand le mal est fait.",
    continuous: "Mesure continue avec Cayus",
    continuousText: "Des comportements, en continu, face à son propre point de départ : lisible pendant qu'il est encore temps d'agir.",
    scienceEyebrow: "Ce qui fonde le modèle",
    scienceTitle: "Le modèle Cayus est co-construit",
    bios: [
      { name: "Antoinette Raymond, PhD", role: "Psychologue organisationnelle · Co-architecte du modèle Cayus", bio: "Ancienne professeure de psychologie & business (Université de San Diego). Trente ans de validation des comportements de leadership dans tous les secteurs." },
      { name: "Rachel Higham", role: "Enterprise Technology Leader · Strategic Advisor", bio: "Trois directions technologiques FTSE 100 : M&S, WPP, BT. Membre des boards GlobalData, PwC et Aldermore Bank." },
    ],
    whoSees: "Qui voit",
    glossEyebrow: "Glossaire express",
    glossTitle: "Les mots de Cayus",
    glossaire: [
  ["Microsoft Graph", "L'API Microsoft 365 par laquelle Cayus lit les signaux de travail du leader consentant."],
  ["Signal", "Une trace de travail élémentaire, une demande envoyée, une réunion tenue, une réponse donnée."],
  ["Behaviour Ladder", "Une des six échelles de comportement observées par Cayus."],
  ["Fenêtre", "La période glissante de 8 semaines sur laquelle les preuves sont lues."],
  ["Baseline", "Le point de référence personnel du leader. Il n'est jamais comparé aux autres."],
  ["Mirror", "La vue privée du manager : invisible pour son propre chef, pour les RH et pour la direction."],
  ["Compass", "Ce qu'il travaille cette semaine : une ou deux choses concrètes, pas plus."],
  ["Radar", "La vue d'ensemble de l'entreprise : des groupes de 8 personnes minimum, décrits avec des mots."],
  ["Building Evidence", "L'état affiché quand la fenêtre ne contient pas assez d'occasions pour se prononcer."],
  ["Le mur", "La frontière d'architecture entre ce que la machine calcule et ce que les humains lisent."],
],
  },

  pourquoi: {
    eyebrow: "Pourquoi Cayus",
    title: "Le management est ce que vous mesurez le moins, alors que c'est ce qui produit vos résultats.",
    impacts: [
      { t: "Garder les personnes qu'on ne veut pas perdre", d: "Voir les signes avant le départ, et non pendant l'entretien de sortie." },
      { t: "L'engagement qui porte la productivité", d: "Voir le désengagement s'installer avant qu'il n'apparaisse dans les chiffres." },
      { t: "Progresser partout à la fois", d: "Améliorer la façon de manager en continu, à tous les niveaux." },
      { t: "Prouver ce que rapporte la formation", d: "Du budget dépensé à l'effet réellement observé, programme par programme." },
    ],
    failTitle: "Pourquoi les outils actuels n'y arrivent pas",
    surveys: "Enquêtes annuelles",
    surveysText: "Un ressenti, déclaré une fois par an, toujours après coup, quand les décisions sont prises et les départs déjà signés.",
    analytics: "Outils de mesure classiques",
    analyticsText: "Ils mesurent tout le monde sans rien demander à personne. Cayus fait l'inverse : uniquement des managers qui ont donné leur accord, et des mots en retour.",
    calcEyebrow: "Le calcul",
    calcTitle: "Ce que ces départs vous coûtent déjà",
    calcLead: "Un calcul économique, pas une mesure de personnes. Toutes les hypothèses sont affichées, et vous pouvez les changer.",
    fEffectif: "Effectif", fTurnover: "Départs par an", fRegrette: "Part de départs regrettés", fCout: "Coût d'un remplacement",
    resultLine: "départs par an, dont",
    resultRegret: "regrettés",
    perYear: "€ / an",
    hypo: "Hypothèse : remplacer une personne coûte l'équivalent de 6 à 9 mois de salaire chargé (recrutement, formation, temps perdu).",
    closing: "Le travail est devenu continu. Le management doit l'être aussi.",
  },

  back: "Retour au site",
  contact: {
    eyebrow: "Contact",
    title: "Contact",
    lead: "Une question sur Cayus, un partenariat ou une demande presse ? Voici comment nous joindre.",
    generalTitle: "Questions générales",
    generalText: "Pour une démo, une candidature au pilote ou une question commerciale.",
    privacyTitle: "Données personnelles",
    privacyText: "Pour toute demande liée au RGPD ou à la protection de vos données.",
    companyTitle: "Informations sur la société",
    companyLegal: "Société à responsabilité limitée immatriculée en Angleterre et au Pays de Galles",
    companyNumber: "Numéro d'immatriculation : 17046973",
    officeTitle: "Siège social",
    websiteTitle: "Site web",
  },
  legal: { privacyEyebrow: "Confidentialité", termsEyebrow: "Conditions", refNote: "Ce document juridique fait foi dans sa version anglaise." },
  securite: {
    eyebrow: "Sécurité & conformité",
    title: "La confiance n'est pas une promesse marketing : elle est inscrite dans la façon dont Cayus est construit.",
    whoTitle: "Qui voit quoi",
    neverLabel: "Ne voit jamais",
    neverTitle: "Ce qui n'existe sur aucun écran",
    dataTitle: "Données et autorisations",
    sideManager: "Côté manager",
    sideManagerText: "Accord donné personne par personne, révocable : sa propre boîte mail, son propre agenda. Le texte est lu une fois pour en tirer une observation, puis effacé.",
    sideCompany: "Côté entreprise",
    sideCompanyText: "Autorisé par la DSI : seulement des informations de contexte, jamais le contenu d'un message. Cela ne sert qu'aux vues d'ensemble par groupes.",
    promise: "Sans manager connecté, aucune donnée n'est lue.",
    colRgpd: "RGPD & comités d'entreprise",
    colAiAct: "Règlement européen sur l'IA",
    colSecu: "Sécurité & juridique",
    faqTitle: "Questions directes, réponses directes",
    altitudes: [
      { a: "Manager", voit: "Sa vue privée (Mirror) : son étape, ses propres mots, ce qu'il travaille cette semaine.", jamais: "La vue des autres, tout classement, toute note." },
      { a: "Senior manager", voit: "Ses propres comportements et l'état de ses relations avec ses managers, vus depuis son seul agenda.", jamais: "La vue privée de ses managers, ce que Cayus leur a dit, leur étape." },
      { a: "RH", voit: "Des services : l'étape la plus fréquente, l'évolution par rapport à leurs propres mois, en mots.", jamais: "Une personne, son étape, le contenu d'un message." },
      { a: "Comité exécutif", voit: "Les tendances de l'ensemble de l'entreprise et ce que deviennent les décisions du comité.", jamais: "Une personne citée nommément, y compris au comité." },
    ],
    jamais: ["Aucun classement", "Aucune note, aucun pourcentage", "Aucune comparaison entre deux personnes", "Aucun nom cité", "Aucun décompte par étape", "Aucun contenu de message d'un collègue", "Aucun usage pour recruter, promouvoir, payer ou licencier", "Aucune note d'aptitude"],
    rgpd: ["Chacun donne son accord et peut le retirer quand il veut.", "Pour ceux qui n'ont pas donné leur accord : uniquement des informations regroupées par 8 personnes minimum, sans nom ni contenu.", "Personne n'est reconnaissable, même en raisonnant par élimination (on masque en dessous de 3).", "Déconnexion à tout moment : la vue privée cesse aussitôt de se remplir.", "Étude d'impact et dialogue avec le CSE prévus dans le plan de déploiement."],
    aiact: ["Un outil de progrès personnel, pour la personne qui a donné son accord.", "Aucun classement ni aucune note utilisable pour recruter, promouvoir, payer, affecter ou licencier : les contrats l'interdisent et les écrans ne le permettent pas.", "Vues d'ensemble : uniquement des groupes, sans aucun nom."],
    secu: ["Données chiffrées et hébergées dans l'Union européenne.", "Autorisations Microsoft réduites au strict nécessaire.", "Démarches ISO 27001 et SOC 2 engagées.", "Accompagnement juridique : Osborne Clarke LLP."],
    faq: [
      ["Mon manager lit-il mes messages ?", "Non. Et le texte de vos propres messages est effacé juste après avoir été lu."],
      ["Les RH voient-elles mon étape ?", "Non. Elles voient des services, jamais des personnes."],
      ["Le chef de mon chef voit-il ma vue privée ?", "Non."],
      ["Que se passe-t-il si je me déconnecte ?", "Votre vue privée cesse aussitôt de se remplir."],
      ["Cayus peut-il servir à une promotion ou à un licenciement ?", "Non. C'est interdit par contrat, et les écrans ne le permettent pas."],
      ["Et mes collègues qui n'ont pas donné leur accord ?", "Uniquement des groupes de 8 personnes minimum, sans aucun nom."],
    ],
  },
};

const en = {
  methodo: {
    eyebrow: "Methodology",
    title: "How Cayus measures, and what never crosses the wall.",
    lead: "On the left, the machine calculates. On the right, people read words. Here is the full journey of one signal.",
    journeyEyebrow: "The journey of a signal",
    journeyTitle: "Seven steps, one wall",
    journey: [
      { t: "Consent", d: "The manager connects their own account, revocable at any time.", who: "nobody" },
      { t: "Reading through Microsoft Graph", d: "Work signals (messages, calendar, meetings) are read through the API.", who: "the machine alone" },
      { t: "One observation, then deletion", d: "The text is read once to draw one observation, then deleted.", who: "nobody, the text no longer exists" },
      { t: "Eight weeks of evidence", d: "Evidence builds up over rolling windows, against their own starting point.", who: "the machine alone" },
      { t: "THE WALL", d: "A step is set when there is enough evidence. Otherwise Building Evidence. No number crosses.", who: "nobody yet", wall: true },
      { t: "Mirror", d: "The manager reads their step, their behaviours explained in one sentence, and their own words.", who: "the manager, alone" },
      { t: "Compass & Radar", d: "What they work on each week; company overviews by groups of eight people minimum, with no names.", who: "HR & leadership, groups described in words, never names" },
    ],
    laddersEyebrow: "The six Behaviour Ladders",
    laddersTitle: "Six behaviours, read in words",
    ladders: [
      { n: "Clear asks", d: "Asks that carry the what, the who and the when.", ex: "Your asks carry the what and the who; the when still slips." },
      { n: "Relationship investment", d: "The attention actually given to working relationships.", ex: "Replies to your own team wait longer than replies upward." },
      { n: "Recognition", d: "Recognising effort as much as results.", ex: "You recognised results more than effort this window." },
      { n: "Sustainable rhythm", d: "A pace of work that holds over time.", ex: "Your evening sending has increased over the last fortnight." },
      { n: "Development focus", d: "The time spent learning and growing others.", ex: "Your learning time disappeared in week five and hasn't returned." },
      { n: "Connecting the organisation", d: "Building links that live without you. (Senior only)", ex: "The pairing you created between your team and operations carried on three times without you." },
    ],
    levelsEyebrow: "The scale",
    levelsTitle: "Four named steps, never a number",
    levels: [
      { n: "Emerging", d: "The behaviour appears, now and then." },
      { n: "Establishing", d: "It repeats, in several contexts." },
      { n: "Consistent", d: "Almost every time, over the long run." },
      { n: "Multiplying", d: "It spreads to others, judged only from the manager's own traces." },
    ],
    buildingQuote: "When the window doesn't hold enough occasions to judge, Cayus says \"building evidence\" rather than guessing.",
    changeEyebrow: "The Change module",
    changeTitle: "Two more behaviours for times of change",
    changeText: "Switched on for declared periods during a transformation: the active windows are visible and chosen, never silent.",
    principesEyebrow: "The principles",
    principesTitle: "Four safeguards",
    principes: [
      "A share of opportunities, never raw volume. Being asked less penalises nobody.",
      "A personal starting point, never a comparison between managers.",
      "No penalty for time off. Absences never damage anything.",
      "Ordered attribution, every piece of evidence sits in the right window and the right context.",
    ],
    survey: "Annual survey",
    surveyText: "Self-reported, once a year, a perception after the fact. The results arrive when the damage is done.",
    continuous: "Continuous measurement with Cayus",
    continuousText: "Behaviour, continuously, against their own starting point, readable while there is still time to act.",
    scienceEyebrow: "The thinking behind the model",
    scienceTitle: "The Cayus model is co-designed",
    bios: [
      { name: "Antoinette Raymond, PhD", role: "Organisational psychologist · Co-architect of the Cayus model", bio: "Former professor of psychology & business (University of San Diego). Thirty years validating leadership behaviours across industries." },
      { name: "Rachel Higham", role: "Enterprise Technology Leader · Strategic Advisor", bio: "Three FTSE 100 technology leadership roles: M&S, WPP, BT. Board member at GlobalData, PwC and Aldermore Bank." },
    ],
    whoSees: "Who sees it",
    glossEyebrow: "Quick glossary",
    glossTitle: "The words Cayus uses",
    glossaire: [
      ["Microsoft Graph", "The Microsoft 365 interface Cayus uses to read the work signals of a manager who opted in."],
      ["Signal", "One basic trace of work, an ask sent, a meeting held, a reply given."],
      ["Behaviour Ladder", "One of the six behaviours Cayus observes."],
      ["Window", "The rolling eight-week period the evidence is read over."],
      ["Baseline", "The manager's own starting point, never compared with anyone else."],
      ["Mirror", "The manager's private view: invisible to their own boss, to HR and to leadership."],
      ["Compass", "What they work on this week: one or two concrete things, no more."],
      ["Radar", "The company overview: groups of eight people minimum, described in words."],
      ["Building Evidence", "What is shown when the window doesn't hold enough occasions to judge."],
      ["The wall", "The line between what the machine calculates and what people read."],
    ],
  },

  pourquoi: {
    eyebrow: "Why Cayus",
    title: "Management is what you measure least, even though it is what produces your results.",
    impacts: [
      { t: "Keep the people you can't afford to lose", d: "See the signs before they leave, not during the exit interview." },
      { t: "The engagement that carries productivity", d: "See disengagement settle in before it shows up in the numbers." },
      { t: "Improve everywhere at once", d: "Raise the way people are managed, continuously, at every level." },
      { t: "Prove what your training delivers", d: "From budget spent to change actually observed, programme by programme." },
    ],
    failTitle: "Why today's tools don't get there",
    surveys: "Annual surveys",
    surveysText: "A feeling, reported once a year, always after the fact, when decisions are made and resignations already signed.",
    analytics: "Traditional measurement tools",
    analyticsText: "They measure everyone without asking anyone. Cayus does the opposite: only managers who opted in, and words in return.",
    calcEyebrow: "The maths",
    calcTitle: "What those departures already cost you",
    calcLead: "A business calculation, not a measure of people. Every assumption is shown, and you can change it.",
    fEffectif: "Headcount", fTurnover: "Departures per year", fRegrette: "Share of regretted departures", fCout: "Cost of one replacement",
    resultLine: "departures per year, of which",
    resultRegret: "regretted",
    perYear: "€ / year",
    hypo: "Assumption: replacing one person costs the equivalent of six to nine months of loaded salary (recruitment, training, lost time).",
    closing: "Work has become continuous. Management has to become continuous too.",
  },

  back: "Back to site",
  contact: {
    eyebrow: "Contact",
    title: "Contact",
    lead: "A question about Cayus, a partnership or a press request? Here is how to reach us.",
    generalTitle: "General enquiries",
    generalText: "For a demo, a pilot application or a commercial question.",
    privacyTitle: "Privacy & data",
    privacyText: "For anything about GDPR or the protection of your data.",
    companyTitle: "Company information",
    companyLegal: "Private limited company registered in England & Wales",
    companyNumber: "Company number: 17046973",
    officeTitle: "Registered office",
    websiteTitle: "Website",
  },
  legal: { privacyEyebrow: "Privacy", termsEyebrow: "Terms", refNote: "The English version of this legal document is the binding one." },
  securite: {
    eyebrow: "Security & compliance",
    title: "Trust isn't a marketing promise: it is built into the way Cayus works.",
    whoTitle: "Who sees what",
    neverLabel: "Never sees",
    neverTitle: "What exists on no screen at all",
    dataTitle: "Data and permissions",
    sideManager: "The manager's side",
    sideManagerText: "Consent given person by person, revocable at any time: their own inbox, their own calendar. Text is read once to draw one observation, then deleted.",
    sideCompany: "The company's side",
    sideCompanyText: "Approved by IT: context information only, never the content of a message. It is only used for the group-level overviews.",
    promise: "With no manager connected, no data is read.",
    colRgpd: "GDPR & works councils",
    colAiAct: "EU AI Act",
    colSecu: "Security & legal",
    faqTitle: "Straight questions, straight answers",
    altitudes: [
      { a: "Manager", voit: "Their private view (Mirror): their step, their own words, what they are working on this week.", jamais: "Anyone else's view, any ranking, any score." },
      { a: "Senior manager", voit: "Their own behaviours and the health of their relationships with their managers, seen from their own diary only.", jamais: "Their managers' private view, what Cayus told them, their step." },
      { a: "HR", voit: "Teams: the most common step, the change against their own months, in words.", jamais: "A person, their step, the content of a message." },
      { a: "Executive committee", voit: "Company-wide trends and what becomes of the committee's decisions.", jamais: "Anyone named, including at the committee." },
    ],
    jamais: ["No ranking", "No score, no percentage", "No comparison between two people", "No names", "No head count per step", "No colleague's message content", "No use for hiring, promotion, pay or dismissal", "No readiness score"],
    rgpd: ["Everyone gives consent and can withdraw it at any time.", "For those who haven't opted in: only information grouped by eight people minimum, with no name and no content.", "Nobody is identifiable, not even by elimination (we hide below three).", "Disconnect at any time: the private view stops filling up immediately.", "Impact assessment and works council consultation planned in the rollout."],
    aiact: ["A personal development tool, for the person who opted in.", "No ranking or score usable for hiring, promotion, pay, assignment or dismissal: contracts forbid it and the screens don't allow it.", "Overviews: groups only, with no names."],
    secu: ["Data encrypted and hosted in the European Union.", "Microsoft permissions kept to the strict minimum.", "ISO 27001 and SOC 2 work under way.", "Legal counsel: Osborne Clarke LLP."],
    faq: [
      ["Does my manager read my messages?", "No. And the text of your own messages is deleted right after being read."],
      ["Can HR see my step?", "No. They see teams, never people."],
      ["Can my manager's manager see my private view?", "No."],
      ["What happens if I disconnect?", "Your private view stops filling up immediately."],
      ["Can Cayus be used for a promotion or a dismissal?", "No. Contracts forbid it, and the screens don't allow it."],
      ["What about colleagues who haven't opted in?", "Groups of eight people minimum only, with no names."],
    ],
  },
};

const es = {
  methodo: {
    eyebrow: "Metodología",
    title: "Cómo mide Cayus, y qué no cruza nunca el muro.",
    lead: "A la izquierda, la máquina calcula. A la derecha, las personas leen palabras. Este es el recorrido completo de una señal.",
    journeyEyebrow: "El recorrido de una señal",
    journeyTitle: "Siete pasos, un muro",
    journey: [
      { t: "Permiso", d: "El manager conecta su propia cuenta, revocable en cualquier momento.", who: "nadie" },
      { t: "Lectura vía Microsoft Graph", d: "Las señales de trabajo (mensajes, agenda, reuniones) se leen a través de la API.", who: "solo la máquina" },
      { t: "Una observación y borrado", d: "El texto se lee una vez para sacar una observación y se borra.", who: "nadie, el texto ya no existe" },
      { t: "Ocho semanas de evidencia", d: "La evidencia se acumula en ventanas móviles, frente a su propio punto de partida.", who: "solo la máquina" },
      { t: "EL MURO", d: "Se fija una etapa cuando hay suficiente evidencia; si no, Building Evidence. Ninguna cifra cruza.", who: "todavía nadie", wall: true },
      { t: "Mirror", d: "El manager lee su etapa, sus comportamientos explicados en una frase y sus propias palabras.", who: "el manager, solo" },
      { t: "Compass y Radar", d: "Lo que trabaja cada semana; vistas de conjunto por grupos de ocho personas como mínimo, sin nombres.", who: "RRHH y dirección, grupos descritos con palabras, nunca nombres" },
    ],
    laddersEyebrow: "Los seis Behaviour Ladders",
    laddersTitle: "Seis comportamientos, leídos con palabras",
    ladders: [
      { n: "Clear asks", d: "Peticiones que llevan el qué, el quién y el cuándo.", ex: "Sus peticiones llevan el qué y el quién; el cuándo todavía se escapa." },
      { n: "Relationship investment", d: "La atención realmente dedicada a sus relaciones de trabajo.", ex: "Las respuestas a su equipo esperan más que las que van hacia arriba." },
      { n: "Recognition", d: "Reconocer el esfuerzo tanto como el resultado.", ex: "Ha reconocido los resultados más que el esfuerzo en esta ventana." },
      { n: "Sustainable rhythm", d: "Un ritmo de trabajo que se sostiene en el tiempo.", ex: "Su envío nocturno ha aumentado en las últimas dos semanas." },
      { n: "Development focus", d: "El tiempo dedicado a aprender y a hacer crecer.", ex: "Su tiempo de aprendizaje desapareció en la semana cinco y no ha vuelto." },
      { n: "Connecting the organisation", d: "Crear vínculos que viven sin usted. (Solo senior)", ex: "La pareja que creó entre su equipo y operaciones continuó tres veces sin usted." },
    ],
    levelsEyebrow: "La escala",
    levelsTitle: "Cuatro etapas con nombre, nunca una cifra",
    levels: [
      { n: "Emerging", d: "El comportamiento aparece, de forma ocasional." },
      { n: "Establishing", d: "Se repite, en varios contextos." },
      { n: "Consistent", d: "Casi siempre, y en el tiempo." },
      { n: "Multiplying", d: "Se contagia a los demás, evaluado solo desde las huellas del propio manager." },
    ],
    buildingQuote: "Cuando la ventana no tiene suficientes ocasiones para juzgar, Cayus dice \"en construcción\" en lugar de adivinar.",
    changeEyebrow: "El módulo Cambio",
    changeTitle: "Dos comportamientos más para las transformaciones",
    changeText: "Se activan en periodos declarados durante una transformación: las ventanas activas son visibles y elegidas, nunca silenciosas.",
    principesEyebrow: "Los principios",
    principesTitle: "Cuatro salvaguardas",
    principes: [
      "Proporción de oportunidades, nunca volumen bruto: que le pidan menos no penaliza a nadie.",
      "Punto de partida personal, nunca comparación entre managers.",
      "Sin penalización por vacaciones: las ausencias no estropean nada.",
      "Atribución ordenada: cada evidencia se sitúa en la ventana y el contexto correctos.",
    ],
    survey: "Encuesta anual",
    surveyText: "Declarativa, una vez al año, una percepción a posteriori: los resultados llegan cuando el daño ya está hecho.",
    continuous: "Medición continua con Cayus",
    continuousText: "Comportamiento, en continuo, frente a su propio punto de partida: legible cuando aún hay tiempo de actuar.",
    scienceEyebrow: "La base del modelo",
    scienceTitle: "El modelo Cayus está co-diseñado",
    bios: [
      { name: "Antoinette Raymond, PhD", role: "Psicóloga organizacional · Co-arquitecta del modelo Cayus", bio: "Ex profesora de psicología y negocios (Universidad de San Diego). Treinta años validando comportamientos de liderazgo en distintos sectores." },
      { name: "Rachel Higham", role: "Enterprise Technology Leader · Strategic Advisor", bio: "Tres direcciones tecnológicas FTSE 100: M&S, WPP, BT. Consejera en GlobalData, PwC y Aldermore Bank." },
    ],
    whoSees: "Quién lo ve",
    glossEyebrow: "Glosario rápido",
    glossTitle: "Las palabras de Cayus",
    glossaire: [
      ["Microsoft Graph", "La interfaz de Microsoft 365 con la que Cayus lee las señales de trabajo del manager que ha dado su permiso."],
      ["Señal", "Una huella básica de trabajo: una petición enviada, una reunión celebrada, una respuesta dada."],
      ["Behaviour Ladder", "Uno de los seis comportamientos que observa Cayus."],
      ["Ventana", "El periodo móvil de ocho semanas sobre el que se lee la evidencia."],
      ["Punto de partida", "La referencia personal del manager: nunca se compara con los demás."],
      ["Mirror", "La vista privada del manager: invisible para su jefe, para RRHH y para la dirección."],
      ["Compass", "Lo que trabaja esta semana: una o dos cosas concretas, no más."],
      ["Radar", "La vista de conjunto de la empresa: grupos de ocho personas como mínimo, descritos con palabras."],
      ["Building Evidence", "Lo que se muestra cuando la ventana no tiene suficientes ocasiones para juzgar."],
      ["El muro", "La frontera entre lo que calcula la máquina y lo que leen las personas."],
    ],
  },

  pourquoi: {
    eyebrow: "Por qué Cayus",
    title: "El management es lo que menos mide, y es justo lo que produce sus resultados.",
    impacts: [
      { t: "Retener a quien no puede perder", d: "Ver las señales antes de la salida, no en la entrevista de salida." },
      { t: "El compromiso que sostiene la productividad", d: "Ver cómo se instala la desconexión antes de que aparezca en las cifras." },
      { t: "Mejorar en todas partes a la vez", d: "Elevar la forma de gestionar, en continuo y en todos los niveles." },
      { t: "Demostrar lo que aporta la formación", d: "Del presupuesto gastado al cambio realmente observado, programa a programa." },
    ],
    failTitle: "Por qué las herramientas actuales no llegan",
    surveys: "Encuestas anuales",
    surveysText: "Una sensación, declarada una vez al año y siempre a posteriori, cuando las decisiones ya están tomadas y las salidas firmadas.",
    analytics: "Herramientas de medición clásicas",
    analyticsText: "Miden a todo el mundo sin pedir permiso a nadie. Cayus hace lo contrario: solo managers que han dado su permiso, y palabras a cambio.",
    calcEyebrow: "El cálculo",
    calcTitle: "Lo que ya le cuestan esas salidas",
    calcLead: "Un cálculo económico, no una medida de personas. Todas las hipótesis están a la vista y puede cambiarlas.",
    fEffectif: "Plantilla", fTurnover: "Salidas al año", fRegrette: "Proporción de salidas lamentadas", fCout: "Coste de una sustitución",
    resultLine: "salidas al año, de las cuales",
    resultRegret: "lamentadas",
    perYear: "€ / año",
    hypo: "Hipótesis: sustituir a una persona cuesta el equivalente a 6-9 meses de salario con cargas (contratación, formación, tiempo perdido).",
    closing: "El trabajo se ha vuelto continuo. El management también debe serlo.",
  },

  back: "Volver al sitio",
  contact: {
    eyebrow: "Contacto",
    title: "Contacto",
    lead: "¿Una pregunta sobre Cayus, una alianza o una consulta de prensa? Así puede contactarnos.",
    generalTitle: "Consultas generales",
    generalText: "Para una demo, una candidatura al piloto o una pregunta comercial.",
    privacyTitle: "Datos personales",
    privacyText: "Para cualquier tema de RGPD o de protección de sus datos.",
    companyTitle: "Información de la empresa",
    companyLegal: "Sociedad limitada registrada en Inglaterra y Gales",
    companyNumber: "Número de registro: 17046973",
    officeTitle: "Domicilio social",
    websiteTitle: "Sitio web",
  },
  legal: { privacyEyebrow: "Privacidad", termsEyebrow: "Condiciones", refNote: "La versión en inglés de este documento legal es la que prevalece." },
  securite: {
    eyebrow: "Seguridad y conformidad",
    title: "La confianza no es una promesa de marketing: está en la forma en que Cayus está construido.",
    whoTitle: "Quién ve qué",
    neverLabel: "Nunca ve",
    neverTitle: "Lo que no existe en ninguna pantalla",
    dataTitle: "Datos y permisos",
    sideManager: "Del lado del manager",
    sideManagerText: "Permiso dado persona por persona y revocable: su propio correo, su propia agenda. El texto se lee una vez para sacar una observación y se borra.",
    sideCompany: "Del lado de la empresa",
    sideCompanyText: "Autorizado por TI: solo información de contexto, nunca el contenido de un mensaje. Sirve únicamente para las vistas por grupos.",
    promise: "Sin manager conectado, no se lee ningún dato.",
    colRgpd: "RGPD y comités de empresa",
    colAiAct: "Reglamento europeo de IA",
    colSecu: "Seguridad y legal",
    faqTitle: "Preguntas directas, respuestas directas",
    altitudes: [
      { a: "Manager", voit: "Su vista privada (Mirror): su etapa, sus propias palabras, lo que trabaja esta semana.", jamais: "La vista de los demás, cualquier clasificación, cualquier nota." },
      { a: "Senior manager", voit: "Sus propios comportamientos y el estado de sus relaciones con sus managers, vistos solo desde su agenda.", jamais: "La vista privada de sus managers, lo que Cayus les dijo, su etapa." },
      { a: "RRHH", voit: "Equipos: la etapa más frecuente y su evolución respecto a sus propios meses, en palabras.", jamais: "Una persona, su etapa, el contenido de un mensaje." },
      { a: "Comité ejecutivo", voit: "Las tendencias de toda la empresa y el destino de las decisiones del comité.", jamais: "Una persona citada por su nombre, también en el comité." },
    ],
    jamais: ["Ninguna clasificación", "Ninguna nota ni porcentaje", "Ninguna comparación entre dos personas", "Ningún nombre citado", "Ningún recuento por etapa", "Ningún contenido de mensajes de compañeros", "Ningún uso para contratar, promocionar, pagar o despedir", "Ninguna nota de aptitud"],
    rgpd: ["Cada persona da su permiso y puede retirarlo cuando quiera.", "Para quienes no lo han dado: solo información agrupada por ocho personas como mínimo, sin nombre ni contenido.", "Nadie es identificable, ni por eliminación (ocultamos por debajo de tres).", "Desconexión en cualquier momento: la vista privada deja de llenarse al instante.", "Evaluación de impacto y diálogo con el comité de empresa previstos en el despliegue."],
    aiact: ["Una herramienta de desarrollo personal, para quien ha dado su permiso.", "Ninguna clasificación ni nota utilizable para contratar, promocionar, pagar, asignar o despedir: los contratos lo prohíben y las pantallas no lo permiten.", "Vistas de conjunto: solo grupos, sin ningún nombre."],
    secu: ["Datos cifrados y alojados en la Unión Europea.", "Permisos de Microsoft reducidos al mínimo necesario.", "Trabajos de ISO 27001 y SOC 2 en marcha.", "Asesoría legal: Osborne Clarke LLP."],
    faq: [
      ["¿Mi manager lee mis mensajes?", "No. Y el texto de sus propios mensajes se borra justo después de leerse."],
      ["¿RRHH ve mi etapa?", "No. Ve equipos, nunca personas."],
      ["¿El jefe de mi jefe ve mi vista privada?", "No."],
      ["¿Qué pasa si me desconecto?", "Su vista privada deja de llenarse al instante."],
      ["¿Puede usarse Cayus para un ascenso o un despido?", "No. Los contratos lo prohíben y las pantallas no lo permiten."],
      ["¿Y mis compañeros que no han dado su permiso?", "Solo grupos de ocho personas como mínimo, sin ningún nombre."],
    ],
  },
};

const PAGES = { fr, en, es };
export const usePages = (language) => PAGES[language] || PAGES.fr;
export default PAGES;
